module.exports = __webpack_public_path__ + "static/img/p1.bd1121e3.png";